import { Navigate } from 'react-router-dom';
import { usePermissions } from '../lib/permissions.js';
import { ADMIN_TABS } from '../components/admin-shell.js';

/**
 * /admin landing — redirects to the first tab the current user can see.
 * Renders nothing on its own; AdminShell provides the tab UI on the
 * destination page.
 */
export function AdminIndexPage(): JSX.Element {
  const { can, data } = usePermissions();
  const isAdmin = data?.role === 'admin';
  const first = ADMIN_TABS.find((t) =>
    t.section ? can(t.section, 'view') : isAdmin,
  );
  if (!first) {
    return (
      <div className="text-sm text-ink-muted">
        You don't have permission to view any admin sections.
      </div>
    );
  }
  return <Navigate to={first.to} replace />;
}
